import React, { useContext } from "react";
import { WebMapContext } from "../../../../../pages/sections/web-map/WebMapGoogleMap";
import { Grid } from "@mui/material";
import { ToggleButtonsComponent } from "../../../common";

const AffluenceFilterComponent = () => {
  const { affluenceLvlFilters, setAffluenceLvlFilters } =
    useContext(WebMapContext);


  const onChange = (value) => {
    setAffluenceLvlFilters((prev) =>
      prev?.map((item) => ({
        ...item,
        isChecked:
          item?.filterName === value?.filterName
            ? item?.isChecked
              ? false
              : true
            : item?.isChecked,
      }))
    );
  };

  return (
    affluenceLvlFilters?.length > 0 && (
      <Grid
        container
        item
        style={{
          margin: "10px 4px 0px",
          padding: "10px",
          background: "#FFFFFF 0% 0% no-repeat padding-box",
          border: "1px solid #007842",
          borderRadius: "4px",
          opacity: "1",
        }}
      >
        <ToggleButtonsComponent
          filters={affluenceLvlFilters}
          onChange={onChange}
        />
      </Grid>
    )
  );
};

export default AffluenceFilterComponent;
